import axios from 'axios';
import qs from "qs";


const domain = axios.create({
    baseURL: URL_DOMAIN_API
});

const applications = ({body}) => domain.post(`domain/applications`, qs.stringify(body))

export default {
    applications
};
